/**
 * Will display a custom Scrollbar for the {@link Transcript} element
 * @class CustomScrollBar
 */
import { debounce } from "./Misc";

export default class CustomScrollBar {
    target: any;

    direction: string;

    bar: any;

    wrapper: HTMLDivElement;

    el: HTMLDivElement;

    moveBarHandler: any;

    scrollRatio: number;

    mouseDownHandler: (e: any) => boolean;

    /**
     * init the customScrollbar class, this will inject a scrollbar and a content div to the Transcript Element
     * @param {Transcript} el
     * @returns {HTMLDivElement}
     */
    init(el) {
        this.target = el;

        this.direction = window.getComputedStyle(this.target).direction;

        this.bar = '<div class="ss-scroll">';

        this.wrapper = document.createElement("div");
        this.wrapper.setAttribute("class", "ss-wrapper");

        this.el = document.createElement("div");
        this.el.setAttribute("class", "ss-content");
        this.el.setAttribute("role", "region");
        this.el.setAttribute("tabindex", "0");

        if (this.direction === "rtl") {
            this.el.classList.add("rtl");
        }

        this.wrapper.appendChild(this.el);

        while (this.target.firstChild) {
            this.el.appendChild(this.target.firstChild);
        }

        this.target.appendChild(this.wrapper);

        this.target.insertAdjacentHTML("beforeend", this.bar);
        this.bar = this.target.lastChild;

        this.dragDealer(this.bar, this);
        this.moveBar();
        this.moveBarHandler = debounce(this.moveBar.bind(this), 10);

        // window.addEventListener('resize', this.moveBarHandler);
        this.el.addEventListener("scroll", this.moveBarHandler);
        this.el.addEventListener("mouseenter", this.moveBarHandler);

        this.target.classList.add("ss-container");

        const css = window.getComputedStyle(el);

        if (css["height"] === "0px" && css["max-height"] !== "0px") {
            el.style.height = css["max-height"]; // eslint-disable-line no-param-reassign
        }

        if (this.el.clientWidth == this.el.offsetWidth) {
            // this.el.style.paddingRight = "18px";
        }
        return this.el;
    }

    /**
     * reinit the scroll bar once after lazy loading happens
     */

    reinit() {
        this.moveBar();
    }

    /**
     * Handles the movement of scrollbar when user scrolls the Transcript Element
     * @param {HTMLDivElement} e
     */
    moveBar(e?) { // eslint-disable-line no-unused-vars
        const totalHeight = this.el.scrollHeight;
        const ownHeight = this.el.clientHeight;
        const _this = this;

        this.scrollRatio = ownHeight / totalHeight;

        const isRtl = _this.direction === "rtl";
        const right = isRtl
            ? (_this.target.clientWidth - _this.bar.clientWidth + 18)
            : (_this.target.clientWidth - _this.bar.clientWidth - 10) * -1;

        window.raf(function () {
            // Hide scrollbar if no scrolling is possible
            if (_this.scrollRatio >= 1) {
                _this.bar.classList.add("ss-hidden");
            } else {
                _this.bar.classList.remove("ss-hidden");

                // calculate the scrollbar div height and top percentage depends upon the Transcript element scroll top position
                const bh = Math.max(_this.scrollRatio * 100, 10);
                _this.bar.style.cssText = `height:${bh}%; top:${Math.min(_this.el.scrollTop / totalHeight * 100, 90)}%;right:${right}px;`; // eslint-disable-line no-mixed-operators
            }
        });
    }

    /**
     *
     * @param {HTMLDivElement} el
     * @param {CustomScrollBar} context
     */
    dragDealer(el, context) {
        let lastPageY;

        this.mouseDownHandler = function (e) {
            lastPageY = e.pageY;
            el.classList.add("ss-grabbed");
            document.body.classList.add("ss-grabbed");

            document.addEventListener("mousemove", drag);
            document.addEventListener("mouseup", stop);

            return false;
        };

        el.addEventListener("mousedown", this.mouseDownHandler);

        function drag(e) {
            const delta = e.pageY - lastPageY;
            lastPageY = e.pageY;

            window.raf(function () {
                context.el.scrollTop += delta / context.scrollRatio; // eslint-disable-line no-param-reassign
            });
        }

        function stop() {
            el.classList.remove("ss-grabbed");
            document.body.classList.remove("ss-grabbed");
            document.removeEventListener("mousemove", drag);
            document.removeEventListener("mouseup", stop);
        }
    }

    /**
     * method to unregister the event handlers
     */
    clear() {
        // w.addEventListener('resize', this.moveBarHandler);
        this.el.removeEventListener("scroll", this.moveBarHandler);
        this.el.removeEventListener("mouseenter", this.moveBarHandler);
        this.el.removeEventListener("mousedown", this.mouseDownHandler);
    }
}
